var render, staticRenderFns
import script from "./passwordManagement.vue?vue&type=script&lang=js&"
export * from "./passwordManagement.vue?vue&type=script&lang=js&"
import style0 from "./passwordManagement.vue?vue&type=style&index=0&id=5e2d4bd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2d4bd0",
  null
  
)

export default component.exports